import React, { useState } from "react";
import { toast } from "sonner";
import { api } from "../../lib/api";
import { tokenHeader, track } from "../../lib/clarity";

const SLOTS = ["Morning (9am–12pm)", "Afternoon (12pm–4pm)", "Evening (4pm–7pm)"];

export default function CallbackForm({ assessmentId, token, onDone }) {
  const t = new Date(Date.now() + 86400000);
  const tomorrow = `${t.getFullYear()}-${String(t.getMonth() + 1).padStart(2, "0")}-${String(t.getDate()).padStart(2, "0")}`;
  const [f, setF] = useState({ phone: "", preferred_date: tomorrow, preferred_time_slot: SLOTS[0], notes: "" });
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (f.phone.replace(/\D/g, "").length < 7) return toast.error("Please enter a valid phone number.");
    setSaving(true);
    try {
      await api.post(`/clarity/${assessmentId}/callback`, f, tokenHeader(token));
      track("callback_request");
      toast.success("Callback requested. Leon will reach out in your chosen window.");
      onDone();
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Could not request a callback.");
    } finally { setSaving(false); }
  };

  return (
    <form data-testid="clarity-callback-form" onSubmit={submit} className="mt-6 grid sm:grid-cols-3 gap-3">
      <input data-testid="callback-phone" type="tel" className="input-exodus" placeholder="Phone *" value={f.phone} onChange={(e) => setF({ ...f, phone: e.target.value })} />
      <input data-testid="callback-date" type="date" min={tomorrow} className="input-exodus" value={f.preferred_date} onChange={(e) => setF({ ...f, preferred_date: e.target.value })} />
      <select data-testid="callback-slot" className="input-exodus" value={f.preferred_time_slot} onChange={(e) => setF({ ...f, preferred_time_slot: e.target.value })}>
        {SLOTS.map((s) => <option key={s}>{s}</option>)}
      </select>
      <input data-testid="callback-notes" className="input-exodus sm:col-span-2" placeholder="Anything you'd like to cover? (optional)" value={f.notes} onChange={(e) => setF({ ...f, notes: e.target.value })} />
      <button data-testid="callback-submit" type="submit" disabled={saving} className="btn-ghost justify-center">{saving ? "Sending…" : "Request callback"}</button>
    </form>
  );
}
